import getProductUsShippingDetailsGql from "@/Apollo/query/product/getProductUsShippingDetails.graphql";
import {
  GetProductUsShippingDetailsQuery,
  GetProductUsShippingDetailsQueryVariables,
} from "@/Apollo/schema";
import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";

/** WHO-6509: a listing's delivery options to the US, unsupported ones included, on `/en-us`. */
export const useProductUsShippingDetails = (
  options: QueryHookOptions<
    GetProductUsShippingDetailsQuery,
    GetProductUsShippingDetailsQueryVariables
  >
) => {
  const currency = useDisplayCurrency();

  return useQuery(
    getProductUsShippingDetailsGql,
    withDisplayCurrency(options, currency)
  );
};
